__turbopack_context__.v({
  "card": "hoverPreview-module-scss-module__BNCB8G__card",
  "cardBack": "hoverPreview-module-scss-module__BNCB8G__cardBack",
  "hoverPreview": "hoverPreview-module-scss-module__BNCB8G__hoverPreview",
  "loader": "hoverPreview-module-scss-module__BNCB8G__loader",
  "tapCatcher": "hoverPreview-module-scss-module__BNCB8G__tapCatcher",
});
